import React, { Component } from 'react'
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Wrapper from '../../../helpers/wrapper';

import NumberFormatter from '../../../shared/utilities/numberformatter';

am4core.useTheme(am4themes_animated);
am4core.addLicense("CH258896422");

export default class RiTreegraph extends Component {

    componentDidMount() {


        let info = this.props

        let card_id = info['card_id'];
        let data = info['graph-data'];
        let dropdownValue = info['dropdownValue']

        //let data = info['graph-data'];

        let chart = am4core.create(card_id, am4charts.TreeMap);
        chart.exporting.menu = new am4core.ExportMenu();

        chart.fontFamily = "Ubuntu"; //TO CHANGE FONT SIZE OF CHART LABELS
        chart.fontSize = 12; //TO CHANGE FONT SIZE OF CHART LABELS

        // Add data
        chart.data = data;

        // FOR FORMATTING LARGE NUMBERS
        if (this.props.isnumber == 'money') {
            chart.numberFormatter.numberFormat = "#.##a";
            chart.numberFormatter.bigNumberPrefixes = [
                { "number": 1e+3, "suffix": "K" },
                { "number": 1e+5, "suffix": "L" },
                { "number": 1e+7, "suffix": "Cr" }
            ];
        } else if (this.props.isnumber == 'number') {
            chart.numberFormatter.numberFormat = "#.##a";
            chart.numberFormatter.bigNumberPrefixes = [
                { "number": 1e+3, "suffix": "K" },
                { "number": 1e+6, "suffix": "M" },
                { "number": 1e+9, "suffix": "G" }
            ];
        }

        chart.maxLevels = 1;
        chart.colors.step = 1;
        // chart.colors.list = [
        //     am4core.color("#038673"),
        //     am4core.color("#038673"),
        //     am4core.color("#038673"),
        //     am4core.color("#db7823"),
        //     am4core.color("#db7823"),
        //     am4core.color("#db7823")
        // ];

        chart.colors.list = [
            am4core.color("#038673"),  //green
            am4core.color("#db7823"),  //yellow
            am4core.color("#d51f30"),  //red
            am4core.color("#038673"),  //green
            am4core.color("#db7823"),  //yellow
            am4core.color("#d51f30"),  //red
            am4core.color("#038673"),  //green
            am4core.color("#db7823"),  //yellow
            am4core.color("#d51f30"),  //red
            am4core.color("#038673"),  //green
            am4core.color("#db7823"),  //yellow
            am4core.color("#d51f30"),  //red
            am4core.color("#038673"),  //green
            am4core.color("#db7823"),  //yellow
            am4core.color("#d51f30"),  //red
            am4core.color("#038673"),  //green
            am4core.color("#db7823"),  //yellow
            am4core.color("#d51f30"),  //red
            am4core.color("#038673"),  //green
            am4core.color("#db7823"),  //yellow
            am4core.color("#d51f30"),  //red

        ];

        // for i in chart.colors.list:
        //     if {value} >

        let level0SeriesTemplate = chart.seriesTemplates.create("0");
        level0SeriesTemplate.strokeWidth = 2;

        // by default only current level series bullets are visible, but as we need brand bullets to be visible all the time, we modify it's hidden state
        level0SeriesTemplate.bulletsContainer.hiddenState.properties.opacity = 1;
        level0SeriesTemplate.bulletsContainer.hiddenState.properties.visible = true;
        // create hover state
        let columnTemplate = level0SeriesTemplate.columns.template;
        let hoverState = columnTemplate.states.create("hover");

        // darken
        hoverState.adapter.add("fill", function (fill, target) {
            if (fill instanceof am4core.Color) {
                return am4core.color(am4core.colors.brighten(fill.rgb, -0.2));
            }
            return fill;
        })

        // add logo
        let image = columnTemplate.createChild(am4core.Image);
        let counter = 0;
        image.opacity = 0.15;
        image.align = "center";
        image.valign = "middle";
        image.width = am4core.percent(80);
        image.height = am4core.percent(80);


        // add adapter for href to load correct image
        image.adapter.add("href", function (href, target) {
            target.events.on("hit", function (ev) {
                if (counter == 0 && counter < 10) {
                    info.parentCallback(dataItem.treeMapDataItem.name.toLowerCase());
                    counter++;
                }

                //
            });
            counter = 0;
            let dataItem = target.parent.dataItem;
            if (dataItem) {
                return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC";
            }
        });

        let level1 = chart.seriesTemplates.create("0");
        let level1_bullet = level1.bullets.push(new am4charts.LabelBullet());
        level1_bullet.locationY = 0.5;
        level1_bullet.locationX = 0.5;
        // Show both accounts and revenue values from data
        level1_bullet.label.html = `
        <div class="d-flex flex-column justify-content-center" style="width: 150px">
            <div class="w-100 d-flex flex-column justify-content-center align-items-center" style="width: 100%">
                <span style="font-size: 13px; color: #fff; font-weight: 600">{name}</span>
            </div>
            <div class="text-left d-flex flex-row justify-content-around">
                <div class="d-flex flex-column justify-content-start">
                    <span style="font-size: 12px; color: #fff; font-weight: 300">{nsv}</span>
                    <span style="font-size: 13px; color: #fff; font-weight: 400">Accounts</span>
                </div>
                <div class="d-flex flex-column justify-content-start">
                    <span style="font-size: 12px; color: #fff; font-weight: 300">{units_sold}</span>
                    <span style="font-size: 13px; color: #fff; font-weight: 400">Revenue</span>
                </div>
            </div>
        </div>`;
        level1_bullet.label.fill = am4core.color("#fff");
        level1_bullet.background.fill = am4core.color("#000")

        let level2 = chart.seriesTemplates.create("1");
        let level2_bullet = level2.bullets.push(new am4charts.LabelBullet());
        level2_bullet.locationY = 0.5;
        level2_bullet.locationX = 0.5;
        level2_bullet.label.text = "{name}";
        level2_bullet.label.fill = am4core.color("#fff");

        let level3 = chart.seriesTemplates.create("2");
        let level3_bullet = level3.bullets.push(new am4charts.LabelBullet());
        level3_bullet.locationY = 0.5;
        level3_bullet.locationX = 0.5;
        level3_bullet.label.text = "{name}";
        level3_bullet.label.fill = am4core.color("#fff");

        chart.dataFields.value = this.props.dropdownValue;
        chart.dataFields.name = "name";
        chart.dataFields.color = "color";
        chart.dataFields.children = "children";
        chart.navigationBar = new am4charts.NavigationBar();
        chart.padding(-10, 20, 20, 20);
        chart.fontFamily = "Ubuntu";//TO CHANGE FONT SIZE OF CHART LABELS
        chart.fontSize = 12;//TO CHANGE FONT SIZE OF CHART LABELS

        //     var tooltipHTML =
        //   `
        //   <div class="w-100 d-flex flex-column justify-space-between" style="width: 100%">
        //     <div class="text-left d-flex flex-column justify-start" style="width: 150px; padding:10px">
        //     <span style="font-size: 12px; color: #7D9EB5; font-weight: 300">{chart.dataFields.name}</span>  
        //     <span style="font-size: 13px; color: #fff; font-weight: 400">{name}: {value}</span>
        //     </div>
        //   </div>
        //   `;

        //   level1.tooltipHTML = tooltipHTML;

        level1.tooltip.getFillFromObject = false;
        level1.tooltip.background.fill = am4core.color("#213345");
        level1.tooltip.background.stroke = am4core.color("#213345");
        level1.tooltip.label.fill = am4core.color("#ffffff");
        level1.tooltip.label.fontSize = 12;

        // level1.columns.template.tooltipHTML = "<table> <tr> <td>{nsv}</br>NSV</td> <td>&nbsp;</td> <td>{value}</br>ASP</td> </tr> <tr> </tr> </table> <hr> <table> <tr> <td>{units_sold}</br>Units Sold</td> <td>&nbsp;</td> <td>{nsv_mix}</br>NSV Mix</td> </tr> </table> ";

        level1.columns.template.tooltipHTML = `
        <div class="w-100 d-flex flex-column justify-space-between" style="width: 100%">
            <div class="w-100 d-flex flex-column justify-space-between" style="width: 100%">
                <span style="font-size: 13px; color: #fff; font-weight: 400">{name}</span>
            </div>
            <div class="text-left d-flex flex-row justify-content-between" style="width: 150px; padding:10px">
                <div class="d-flex flex-column justify-content-start">
                    <span style="font-size: 12px; color: #7D9EB5; font-weight: 300">{nsv}</span>
                    <span style="font-size: 13px; color: #fff; font-weight: 400">Accounts</span>
                </div>
                <div class="d-flex flex-column justify-content-start">
                    <span style="font-size: 12px; color: #7D9EB5; font-weight: 300">{units_sold}</span>
                    <span style="font-size: 13px; color: #fff; font-weight: 400">Revenue</span>
                </div>
            </div>
        
        </div>
        </div>  
        `;

        level2.tooltip.getFillFromObject = false;
        level2.tooltip.background.fill = am4core.color("#213345");
        level2.tooltip.background.stroke = am4core.color("#213345");
        level2.tooltip.label.fill = am4core.color("#ffffff");
        level2.tooltip.label.fontSize = 12;

        level3.tooltip.getFillFromObject = false;
        level3.tooltip.background.fill = am4core.color("#213345");
        level3.tooltip.background.stroke = am4core.color("#213345");
        level3.tooltip.label.fill = am4core.color("#ffffff");
        level3.tooltip.label.fontSize = 12;


    }

    handleBreadcrumb = (evt) => {
        this.props.parentCallback2(evt)
    }

    render() {

        let card_class = this.props.card_class;
        let card_id = this.props.card_id;

        // Always start breadcrumb with 'HOME'
        const breadcrumbItems = ["HOME", ...(this.props.Deep_Dive_BreadCrumb || [])];

        // Custom styles for breadcrumb to match chart design
        const breadcrumbStyle = {
            background: 'transparent',
            padding: '8px 0',
            marginBottom: '8px',
            marginLeft: '12px',
            fontFamily: 'Ubuntu, sans-serif',
            fontSize: 16,
        };
        const itemStyle = {
            color: '#11A1FD', // main chart color
            fontWeight: 500,
            cursor: 'pointer',
            textDecoration: 'none',
        };
        const activeItemStyle = {
            ...itemStyle,
            color: '#213345', // dark color for active
            fontWeight: 700,
            cursor: 'default',
        };

        return (
            <Wrapper>
                <div style={breadcrumbStyle}>
                    {breadcrumbItems.map((item, index) => (
                        <span
                            key={index}
                            style={index === breadcrumbItems.length - 1 ? activeItemStyle : itemStyle}
                            onClick={index === breadcrumbItems.length - 1 ? undefined : () => this.handleBreadcrumb(index)}
                        >
                            {item.toUpperCase()}
                        </span>
                    )).reduce((prev, curr, idx) => prev === null ? [curr] : [...prev, <span key={'sep-' + idx} style={{ color: '#038673', fontWeight: 700, margin: '0 6px' }}>/</span>, curr], null)}
                </div>
                <div id={card_id} className={card_class}></div>
            </Wrapper>
        )
    }
}
